import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, User } from 'lucide-react';
import { useMembers } from '../api/queries';

const PAGES = [
  { kind: 'Seite', label: 'Dashboard', to: '/' },
  { kind: 'Seite', label: 'Mitglieder', to: '/mitglieder' },
  { kind: 'Seite', label: 'Sektionen', to: '/sektionen' },
  { kind: 'Seite', label: 'Statistik', to: '/statistik' },
  { kind: 'Seite', label: 'Benutzer', to: '/benutzer' },
  { kind: 'Seite', label: 'Einstellungen', to: '/einstellungen' },
];

export function CommandPalette({ open, onClose }: { open: boolean; onClose: () => void }) {
  const nav = useNavigate();
  const [q, setQ] = useState('');
  const { data: members } = useMembers({});
  useEffect(() => { if (open) setQ(''); }, [open]);

  const items = useMemo(() => {
    const memberItems = (members ?? [])
      .filter((m) => m.status === 'aktiv')
      .map((m) => ({
        kind: 'Mitglied' as const,
        label: `${m.vorname} ${m.nachname}`,
        sub: `Nr. ${String(m.mitgliedsnummer).padStart(3, '0')} · ${m.ort ?? ''}`,
        to: `/mitglieder/${m.id}`,
      }));
    return [...PAGES, ...memberItems];
  }, [members]);

  const filtered = q
    ? items.filter((i) => (i.label + ' ' + ('sub' in i ? i.sub : '')).toLowerCase().includes(q.toLowerCase())).slice(0, 30)
    : items.slice(0, 8);

  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose} style={{ alignItems: 'flex-start', paddingTop: '12vh' }}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 560 }}>
        <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border-subtle)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <Search size={18} />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            autoFocus
            placeholder="Mitglied suchen oder Seite öffnen…"
            style={{ flex: 1, border: 'none', outline: 'none', fontSize: 16, background: 'transparent', color: 'var(--text-primary)' }}
          />
          <span className="kbd-key">esc</span>
        </div>
        <div className="scroll-area" style={{ maxHeight: 400, padding: 6 }}>
          {filtered.length === 0 && (
            <div style={{ padding: 32, textAlign: 'center', color: 'var(--text-tertiary)' }}>
              Keine Treffer für „{q}"
            </div>
          )}
          {filtered.map((it, i) => (
            <button
              key={i}
              onClick={() => { nav(it.to); onClose(); }}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: 11,
                padding: '9px 10px', borderRadius: 8, textAlign: 'left',
                color: 'var(--text-primary)', background: 'transparent', border: 'none', cursor: 'pointer',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--bg-hover)')}
              onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
              {it.kind === 'Seite' ? <Search size={16} /> : <User size={16} />}
              <span style={{ flex: 1 }}>
                <span style={{ fontWeight: 500 }}>{it.label}</span>
                {('sub' in it) && (it as { sub?: string }).sub && (
                  <span style={{ color: 'var(--text-tertiary)', marginLeft: 8, fontSize: 13 }}>· {(it as { sub: string }).sub}</span>
                )}
              </span>
              <span style={{ fontSize: 11.5, color: 'var(--text-tertiary)' }}>{it.kind}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
